export default "__VITE_ASSET__Hsb6bnur__"